module.exports = __webpack_public_path__ + "static/media/get_restocked_magically.4a5782d7.svg";